import React, {useEffect} from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import {
    HeaderComponent,
    NavbarComponent,
    FooterComponent,
    BenefitComponent,
    Claim,
    Benefits,
    PaymentFailed,
    PaymentSuccess
} from '../../presentation';
import { DataGetService } from '../../domain';

export default function MainLayout() {
    const location = useLocation(); // Get the current path
    const [paramsData, setParamsData] = React.useState([]);
    const _DataGetService = new DataGetService();

    // Define routes where BenefitComponent and other should NOT be visible
    const hideComponentsOnRoutes = ['/faq', '/success', '/failed'];

    const parametersGet = async () => {
        try {
            const paramsList = ['BPI_SUSTAINABILITY_LOGO'];

            const { parameters = [] } = await _DataGetService.execute();
            const filteredParams = parameters?.filter?.((item) => paramsList.includes(item.paramName)) || [];
            setParamsData(filteredParams);
        } catch (error) {
            console.error('Error fetching parameters:', error);
        }
    };

    useEffect(() => {
        parametersGet();
    }, []);

    return (
        <div>
            <NavbarComponent />
            <HeaderComponent />
            {!hideComponentsOnRoutes.includes(location.pathname) && <BenefitComponent />}
            <Outlet />

            {location.pathname !== '/faq' && location.pathname !== '/kyc' && <Claim />}

            <FooterComponent paramsData={paramsData} />
        </div>
    );
}
